import client from './client';

interface FaceValidationError {
  error: string;
  code: 'no_face' | 'multiple_faces' | 'low_quality';
  faceCount: number;
}

export const facePhotoApi = {
  /**
   * Upload or replace the user's face selfie.
   * Validates that the image contains exactly one clear face.
   */
  upload: async (file: File | Blob): Promise<{ facePhotoKey: string }> => {
    const formData = new FormData();
    formData.append('photo', file);
    const res = await client.post<{ message: string; facePhotoKey: string }>(
      '/auth/me/face-photo',
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } },
    );
    return res.data;
  },

  /**
   * Upload an optional enrollment-angle selfie (left/right turned face) to
   * improve matching on off-angle event photos. Requires a main selfie first.
   */
  uploadAngle: async (file: File | Blob, angle: 'left' | 'right'): Promise<{ angle: string }> => {
    const formData = new FormData();
    formData.append('photo', file);
    formData.append('angle', angle);
    const res = await client.post<{ message: string; angle: string }>(
      '/auth/me/face-angle',
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } },
    );
    return res.data;
  },

  /** Delete the user's face selfie. */
  delete: () =>
    client.delete('/auth/me/face-photo').then((r) => r.data),

  /** Check if an error response is a face validation error. */
  isFaceValidationError: (err: unknown): err is { response: { data: FaceValidationError; status: number } } => {
    const e = err as { response?: { data?: { code?: string }; status?: number } };
    return e?.response?.status === 422 && !!e?.response?.data?.code;
  },
};
